import React, { useEffect, useRef, useState } from 'react'
import { aimessagingProps, chatItemInterface, chatsArray } from './aimessaging-interface'
import { RootState } from '../../../store/store'
import { useSelector } from 'react-redux'
import { Form, Input } from 'antd'
import moment from 'moment'
import { askIAQuestion, getChatWithAi } from '../../../api/ai/aitutor'
import { openNotificationWithIcon } from '../../../utils/helper'
import {
	LoadingOutlined,
} from '@ant-design/icons';

const Aimessaging = ({ updateShowAIMessageScreen }: aimessagingProps) => {
	const [form] = Form.useForm();
	const chatContainerRef = useRef<HTMLDivElement | null>(null)

	const [submitting, setSubmitting] = useState(false)
	const [loadingChats, setLoadingChats] = useState(false)

	const [chats, setChats] = useState<chatsArray>([

	])


	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state


	const scrollToBottom = () => {
		const container = chatContainerRef.current;
		if (container) {
			container.scrollTo({
				top: container.scrollHeight,
				behavior: 'smooth'
			});
		}
	};

	const updateChat = (value: chatItemInterface) => {
		setChats((prevArray) => {
			const updatedArray = [...prevArray, value];
			return updatedArray;
		});
	};

	const fetchAIChat = async () => {
		try {
			setLoadingChats(true)
			const res = await getChatWithAi()
			const { data } = res.data
			const newChat: chatsArray = data.conversations.map((item: any) => {
				return {
					text: item.body,
					chatType: item.creatorId === user?._id ? 'my-chat' : 'client-chat'
				}
			})
			setChats(newChat)
			setLoadingChats(false)
		} catch (error) {
			setLoadingChats(false)
		}
	}

	useEffect(() => {
		fetchAIChat()

		// eslint-disable-next-line
	}, [])


	const onFinish = async (values: any) => {
		const { question } = values
		try {
			if (question.trim().length > 0) {

				updateChat(
					{
						chatType: 'my-chat',
						text: question
					}
				)


				setSubmitting(true)
				form.resetFields()

				const res = await askIAQuestion({
					question
				})

				updateChat(
					{
						chatType: 'client-chat',
						text: res.data.data
					}
				)

				setSubmitting(false)

			}
		} catch (error: any) {
			setSubmitting(false)
			if (error?.response) {
				openNotificationWithIcon('error', 'AI Tutor Chat', `${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'AI Tutor Chat', 'Something went wrong')
			}
		}
	}

	const handleKeyPress = (event: any) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			form.submit()
		}
	};

	useEffect(() => {
		scrollToBottom()
	}, [chats])


	return (
		<div className='w-[30rem] fixed bg-appcolorwhite z-[2] bottom-0 left-[16rem] p-[0.9rem] custom-box-shadow-three'
			style={{
				borderRadius: '30px 30px 0px 0px'
			}}
		>
			<div className='bg-appcolorgreyfainttwo rounded-[15px] px-[0.9rem] py-[0.5rem] flex justify-between'>
				<div className='flex items-center'>
					<div className='pr-2'>
						<img src={user?.aiTutorDetails?.image} alt="aiimage" className='w-[1.3rem] h-[1.3rem]' />
					</div>

					<p className='font-medium text-appcolorblack text-[18px] leading-[22px]'>
						{
							user?.aiTutorDetails?.name
						}
					</p>
				</div>

				<div className='flex items-center'>
					<div className='mr-[1.25rem]'>
						<img src="/img/vectors/expandai.svg" alt="" className='w-[1.25rem] h-[1.25rem] cursor-pointer' />
					</div>
					<div>
						<img src="/img/vectors/aiclose.svg" alt=""
							className='w-[1.25rem] h-[1.25rem] cursor-pointer'
							onClick={() => [
								updateShowAIMessageScreen(false)
							]}
						/>
					</div>
				</div>
			</div>

			<div className='overflow-x-scroll max-h-[20rem] mt-[1.25rem] flex flex-col'
				ref={chatContainerRef}
			>
				{
					loadingChats ?
						<div className='flex flex-col items-center'>
							<LoadingOutlined
								className='text-xl'
							/>
							<span className='text-sm text-center'>Getting your messages with {user?.aiTutorDetails?.name}</span>
						</div>
						:
						<>
							{
								chats.map((item: any) => (
									item.chatType === 'my-chat' ?
										<div className="my-chat" key={`chat-${moment.now()}`}>
											<p className='w-fit'>
												{item.text}
											</p>
										</div>
										:
										<div className="client-chat" key={`chat-${moment.now()}`}>
											<p>
												{item.text}
											</p>
										</div>
								))
							}
						</>
				}



				{/* <div className="my-chat">
					<p className='w-fit'>
						What is python
					</p>
				</div> */}

				{/* <div className="client-chat">
					<p>
						Python is a programming language that people use to tell computers what to do. It's like a special kind of language that computers can understand and follow instructions from. Just like we use words and sentences to communicate with each other, programmers use Python to communicate with computers.

					</p>
				</div> */}

			</div>

			{
				!loadingChats ?
					<div className='my-[1.4rem]'>
						<div className='flex items-center'>
							<div className='grow'>
								<Form
									form={form}
									onFinish={onFinish}
								>
									<Form.Item
										name="question"
										hasFeedback={submitting}
										validateStatus={submitting ? 'validating' : undefined}
									>
										<Input
											size="small"
											placeholder={`${chats.length === 0 ? 'Ask a question' : 'Your Reply Here'}`}
											bordered={false}
											className="w-full mr-4 bg-appcolorgreyfainttwo custom-transparent-input-ai-message"
											style={{
												width: '100%',
											}}
											onKeyPress={handleKeyPress}
										/>
									</Form.Item>
								</Form>
							</div>
							<div className='pl-[0.8rem] mb-6'>
								<img src="/img/vectors/aireply.svg" alt="" className='h-full cursor-pointer'
									onClick={() => {
										if (!submitting) {
											form.submit()
										}
									}}
								/>
							</div>
						</div>
					</div>
					:
					null
			}
		</div>
	)
}

export default Aimessaging